import { isCompany, isValid } from 'kennitala-utility';
import { Params } from 'react-router-dom';
import { ENTITY_TYPE, FLOW_TYPE, FlowType } from 'consts';
import { isEmail, isPhoneNumber } from 'helpers';

export function QueryParams(...arg: string[]) {
	const params = new URLSearchParams(window.location.search);
	return arg.map(key => params.get(key) || '');
}

export function AppParams(params: Readonly<Params<string>>) {
	return {
		entityType: ENTITY_TYPE.LEGAL_ENTITY === params.entityType ? ENTITY_TYPE.LEGAL_ENTITY : ENTITY_TYPE.INDIVIDUAL,
		flowType: (params.flowType || FLOW_TYPE.MV) as FlowType
	};
}

export function UserParams() {
	const params = new URLSearchParams(window.location.hash.replace('#', '?'));
	const companyKennitala = params.get('companyKennitala') ?? '';
	const accessAoken = params.get('access_token') ?? '';
	const kennitala = params.get('kennitala') ?? '';
	const email = params.get('email') ?? '';
	const error = params.get('error') ?? '';
	const phone = params.get('phone') ?? '';
	return {
		accessAoken,
		companyKennitala: isValid(companyKennitala) && isCompany(companyKennitala) ? companyKennitala : '',
		email: isEmail(email) ? email : '',
		error,
		kennitala: isValid(kennitala) && !isCompany(kennitala) ? kennitala : '',
		phone: isPhoneNumber(phone) ? phone : ''
	};
}
